import { createReducer } from '@reduxjs/toolkit';
import { fetchBadges, registerProductEnrichmentOptions, } from './product-enrichment-actions.js';
import { getProductEnrichmentInitialState, } from './product-enrichment-state.js';
export const productEnrichmentReducer = createReducer(getProductEnrichmentInitialState(), (builder) => {
    builder
        .addCase(registerProductEnrichmentOptions, (state, action) => {
        state.productId = action.payload.productId;
        state.placementIds = action.payload.placementIds ?? [];
    })
        .addCase(fetchBadges.pending, (state) => {
        state.isLoading = true;
        state.error = null;
    })
        .addCase(fetchBadges.fulfilled, (state, action) => {
        handleFulfilled(state);
        state.products = action.payload.response.products;
    })
        .addCase(fetchBadges.rejected, (state, action) => {
        handleError(state, action.payload);
    });
});
function handleError(state, error) {
    state.error = error || null;
    state.isLoading = false;
    state.products = [];
}
function handleFulfilled(state) {
    state.error = null;
    state.isLoading = false;
}
